/* eslint-disable react/require-default-props */
import url from '@/utils/config';
import Router from 'next/router';
import { ReactNode } from 'react';

type Props = {
  children?: ReactNode;
};

/**
 * ブラウザ履歴を1つ戻るための共通ボタン。
 * @param param0 ボタン文言
 * @returns 戻るボタン
 */
const RouterBackButton = ({ children = '戻る' }: Props) => {
  return (
    <a
      role='button'
      tabIndex={0}
      className='m-button-back__inner'
      onClick={(e) => {
        // フォーム内でもブラウザ履歴へ戻したいため、通常リンク遷移ではなく Router.back を使う。
        e.preventDefault();
        Router.back();
      }}
      onKeyDown={(e) => {
        // キーボード操作でも同じ戻る挙動になるよう Enter/Space を処理する。
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          Router.back();
        }
      }}
      style={{ cursor: 'pointer' }}
    >
      <img className='m-button__icon' src={url('/images/icon-arrow_left.svg')} alt='' />
      <span className='m-button-back__txt'>{children}</span>
    </a>
  );
};

export default RouterBackButton;
